import { Body1, Button, UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';
import { NBSP } from 'shared/constants/symbols';

import * as styles from './styles.css';

export interface IMortgageRateHikeBannerProps {
  onButtonClick: () => void;
}

export const MortgageRateHikeBanner: React.FC<IMortgageRateHikeBannerProps> = ({ onButtonClick }) => {
  return (
    <div className={styles['container']} data-testid="MortgageRateHikeBanner">
      <div className={styles['content']}>
        <div className={styles['text-group']}>
          <UIHeading1 color="text-inverted-default">
            С{NBSP}1{NBSP}октября{NBSP}— дороже
          </UIHeading1>
          <Body1 color="text-inverted-default">
            Выберите семейное жильё на{NBSP}прежних{NBSP}условиях
          </Body1>
        </div>

        <Button
          data-testid="MortgageRateHikeBannerButton"
          size="M"
          theme="inverted"
          type="button"
          onClick={onButtonClick}
        >
          Закрыть
        </Button>
      </div>

      <div aria-hidden={true} className={styles['image-slot']} />
    </div>
  );
};
